import { ClassNameValue } from "tailwind-merge";

import StatusBadge, { StatusTone } from "@buildpy/ui/status-badge";
import {
  CUSTOMER_STAGE_LABEL,
  CustomerStage,
} from "@buildpy/core/modules/customer/types";

// 고객 단계 → 톤. 상담·견적은 둘 다 진행 중이라 같은 톤이고 글자로 가른다.
export const STAGE_TONE: Record<CustomerStage, StatusTone> = {
  NEW: "new",
  CONTACTED: "progress",
  QUOTED: "progress",
  WON: "done",
  LOST: "dropped",
};

interface Props {
  stage: CustomerStage;
  isInteractive?: boolean;
  className?: ClassNameValue;
}

const StageBadge = ({ stage, isInteractive, className }: Props) => (
  <StatusBadge
    className={className}
    interactive={isInteractive}
    label={CUSTOMER_STAGE_LABEL[stage]}
    tone={STAGE_TONE[stage]}
  />
);

export default StageBadge;
